import { defineStore } from 'pinia'
import { IStore } from '@/system-modules/share/v1/core/interface/IStore'
import { EnumViewMode } from '@/contracts/system-modules/share/enum/EnumViewMode'

export default defineStore('systemShareStoreV1', {
  state: (): IStore => {
    return {
      mode: EnumViewMode.OWNER,
      ownerUuid: '',
      page: null,
      linkUuid: null,
      linkZone: '',
      viewers: [],
      owners: [],
      links: [],
    }
  },
})
